/*
 * The public collection page's centered content column: `min(100% - buffer, pageMaxWidth)` with a
 * 0 buffer below `sm` and 80px (40px per side) above it, clamped to the --share-link-page-max-width
 * var the page root hosts (see `getShareLinkPageMaxWidthStyle`). The buffer lives in the width
 * expression rather than as horizontal padding for two reasons: the header and grid inside the
 * column already apply their own horizontal padding (adding column padding would double-pad them),
 * and external consumers reuse this exact class (e.g. the workspace header's constrained content)
 * so their edges stay aligned with the column at every viewport — padding on the column but not on
 * those consumers would break that alignment. Collection-only: the public board page's column has
 * a different buffer and absent-value contract (see `boardPageColumn.ts`).
 */
export const SHOWCASE_PAGE_COLUMN_CLASS_NAME =
  'mx-auto w-full max-w-[var(--share-link-page-max-width)] sm:max-w-[min(100%_-_80px,var(--share-link-page-max-width))]';
